<template>
  <div class="middle-content">
    <div id="map-blur" class="map-blur">
      <div class="map-blur-text" v-html="msg"></div>
      <div class="map-blur-image"></div>
    </div>
    <div id="map-container" class="map-container on-left"></div>
  </div>
</template>

<script>
import { i18nMixin } from '../../modules/shared/mixins/i18n.mixin';
import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import { CONFIG } from '../../config';
import { getCountry } from '../../utils.js';

var mgr = new UserManager({ response_mode: 'query', userStore: new WebStorageStateStore() });

export default {
  name: 'Redirect',

  props: {},

  mixins: [i18nMixin],

  data() {
    let message = {
      msg: `
        <h2>Redirecionando</h2>
        <p>Você está sendo redirecionado para o GIG...</p>
        <p>Caso o GIG não carregue, verifique a URL desta página e acesse a plataforma pelo link padrão, sem caracteres extras:</p>
        <a href="${CONFIG.URL.NEOGIG_HOST}"><strong>${CONFIG.URL.NEOGIG_HOST}</strong></a>
      `
    };

    if (getCountry() !== 'br') {
      message = {
        msg: `
        <h2>Redireccionando</h2>
        <p>Está siendo redirigido a GIG...</p>
        <p>Si GIG no se carga correctamente, verifique la URL de esta página y acceda a la plataforma utilizando el enlace oficial, sin caracteres adicionales:</p>
        <a href="${CONFIG.URL.NEOGIG_HOST}"><strong>${CONFIG.URL.NEOGIG_HOST}</strong></a>
      `};
    };

    return message;
  },

  mounted() {
    mgr
      .signinRedirectCallback()
      .then(function(user) {
        window.location.href = '/';
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/callback/callback.vue